<script setup>
import XeroLogo from "@/images/XeroLogoSVG.vue"

const props = defineProps({
	invoiceId: {
		type: String,
		required: true,
	},
})

function openInXero(){
	window.open(`https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=${props.invoiceId}`, '_blank')
}

</script>

<template>
	<Button 
		@click.stop.prevent="openInXero" 
		class="w-24" 
		color="blue"
		variant="outline"
		size="sm"
		data-testid="open-in-xero-btn"
	>
		<XeroLogo class="w-11 h-3 fill-Blue" />
	</Button>
</template>

